import React, { FC } from 'react';
import { User } from '@vis-auth/vis-user-client';
import { useAccount } from '../../../context/Account/AccountContext';
import { useUser } from '../../../context/User/UserContext';
import './HomeHeader.scss';

const HomeHeader: FC = () => {
  const { firstName } = useUser() as User;
  const { companyInfo } = useAccount();

  return (
    <div className="ver-page-header eve-home-header-container">
      <div className="grid-container ver-page-header__title eve-home-header">
        <h1>Welcome back, {firstName}!</h1>
        <p>Here is what is happening in {companyInfo.companyName}’s account today</p>
      </div>
    </div>
  );
};

export default HomeHeader;
